import api from "~/store/api"

export const setTranslation = (typeData, data) => {
  const { type_id, type } = typeData
  if (data.id === null) delete data.id
  return api
    .post(`${type}/${type_id}/translations`, data)
    .then((res) => res.data.data)
}
